import { GUIDE_CREATED } from '../track-events-types';
import { isNpsGuide } from '@/stores/helpers/guides.helper';
import get from 'lodash/get';

export function fireGuideCreatedTrackEvent (guide, location = '') {
    const { id: guideId, appId, attributes, launchMethod } = guide;
    const isResourceCenter = !!get(guide, 'attributes.resourceCenter');
    const isAnnouncement = !!get(guide, 'attributes.isAnnouncement');
    const wasCreatedByConversationalAi = !!get(guide, 'attributes.createdByConversationalAi');

    if (!isResourceCenter && !isAnnouncement) {
        window.pendo.track(GUIDE_CREATED, {
            guideId,
            launchMethod,
            appId,
            ...(location ? { location } : {}),
            sharedServiceVersion: attributes.sharedServiceVersion,
            isConfirmation: !!get(guide, 'attributes.badge.isConfirmation'),
            isNps: isNpsGuide(guide),
            wasCreatedByConversationalAi,
        });
    }
}
